// @TODO abstract any shared stuff (color vars, etc) here
var colorLightGray = "#f5f5f5";
var styles = {
  colorLightGray: colorLightGray,
  sectionDivider: {
    paddingLeft: "6px",
    // borderTop: '2px solid #ddd',
    // borderBottom: '2px solid #ddd',
    background: colorLightGray,
    fontWeight: "bold",
    textTransform: "uppercase"
  },
  buttonReset: {
    background: "transparent",
    border: "0",
    padding: "0"
  }
};
export default styles;